module.exports = __webpack_public_path__ + "static/sport/bgi-form.2381078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/bgi-form.png
// module id = cVph
// module chunks = 0